import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useMessages } from "../global/messagesContext";

const Title = styled.div`
    position: relative;
    width: 100%;
    height: 72px;
    border: 1px solid #C0C0C0;
    background-color: #FFCF3D;
    z-index: 1000;
    display: flex;
    align-items: center;
    padding-left: 160px;
    justify-content: space-between;
`;

const ContainerText = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 120px;
`;

const CloseIcon = styled.img`
    width: 10px;
    height: 10px;
    cursor: pointer;
    margin: 0px 16px;
`;

const Text = styled.h3`
    color: #000;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
`;

const TextButton = styled.p`
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-transform: uppercase;
    cursor: pointer;
`;

const Button = styled.button`
    display: flex;
    width: 151px;
    height: 48px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #000;
    background: transparent;
    cursor: pointer;
    position: relative;
    z-index: 1;
`;

const MessageNotice = ({ currentRoute }) => {
    const { data, showMessageNotice, setShowMessageNotice } = useMessages();
    const highlightMessage = data?.find(item => item.highlight === true);
    let navigate = useNavigate();

    if (currentRoute === "/notice" || !showMessageNotice) {
        return null;
    }

    return (
        <Title>
            <Container>
                <ContainerText>
                    <img width={24} height={24} src='/img/alert-hexagon-v2.svg' alt='ícone de alerta' />
                    <Text>
                        {highlightMessage?.title}
                    </Text>
                </ContainerText>
                <Button onClick={() => {
                    navigate("/notice");
                    setShowMessageNotice(false);
                }}>
                    <TextButton>
                        VER DETALHES
                    </TextButton>
                </Button>
            </Container>
            <CloseIcon onClick={() => setShowMessageNotice(false)} src='/img/close-icon.svg' alt='ícone de fechar' />
        </Title>
    );
};

export default MessageNotice;
